module.exports = __webpack_public_path__ + "static/media/eagle.a6894b92.png";